import { Component, Inject, inject, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_DATE_FORMAT } from 'src/app/data/constants/Data';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import moment, { Moment } from 'moment';

export interface RfqDeadlineDialogData {
  rfqNumber: string;
  initialSentDate: Date;
  rfqDeadline: Date;
  newRFQDeadline?: Date;
}

export interface RfqDeadlineDialogActionResult {
  dialogData: RfqDeadlineDialogData;
  dialogForm: {
    newRFQDeadline: Date | null;
  };
}

export type RfqDeadlineDialogResult = undefined | RfqDeadlineDialogActionResult;

@Component({
  selector: 'app-rfq-deadline-dialog',
  templateUrl: './rfq-deadline-dialog.component.html',
  styleUrls: ['./rfq-deadline-dialog.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMAT },
  ],
})
export class RfqDeadlineDialogComponent implements OnInit {
  dialogForm = new FormGroup({
    newRFQDeadline: new FormControl<Moment | null>(null),
  });
  constructor(
    public dialogRef: MatDialogRef<RfqDeadlineDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RfqDeadlineDialogData
  ) {}

  ngOnInit() {
    if (this.data.newRFQDeadline) {
      this.dialogForm.controls['newRFQDeadline'].setValue(
        moment(this.data.newRFQDeadline)
      );
    }
  }

  getMinNewDeadline(rfqDeadline:Date) {
    return moment(rfqDeadline).add(1, 'days').toDate();
    // return moment(rfqDeadline).toDate();

  }

  validateForm() {
    const newRFQDeadline = this.dialogForm.get('newRFQDeadline')?.value;

    // Reset error state
    this.dialogForm.controls['newRFQDeadline'].setErrors(null);
    this.dialogForm.controls['newRFQDeadline'].markAsTouched();

    // Validate
    if (!newRFQDeadline) {
      this.dialogForm.controls['newRFQDeadline'].setErrors({
        missingNewRFQDeadline: true,
      });
    }

    // if (
    //   newRFQDeadline &&
    //   moment(newRFQDeadline).isBefore(moment(this.getMinNewDeadline()))
    // ) {
    //   this.dialogForm.controls['newRFQDeadline'].setErrors({
    //     invalidNewRFQDeadline: true,
    //   });
    // }
  }

  onDialogAction() {
    this.validateForm();

    // Block form from closing if validation failed
    if (this.dialogForm.invalid) {
      return;
    }

    const formValues = this.dialogForm.value;
    // Set newRFQDeadline to have same hour, minute, second as existing RFQDeadline
    const mRFQDeadline = moment(this.data.rfqDeadline);
    const dNewRFQDeadline = formValues['newRFQDeadline']
      ? moment(
          `${formValues['newRFQDeadline'].format(
            'YYYY-MM-DD'
          )}T${mRFQDeadline.format('HH:mm:ss')}`
        ).toDate()
      : null;

    // Return dialog results to parent component after closing
    const result = {
      dialogData: this.data,
      dialogForm: { ...formValues, newRFQDeadline: dNewRFQDeadline },
    };

    this.dialogRef.close(result);
  }
}
